var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 25,
    rx: 2.83333,
    fill: "#5078C8",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 25,
    rx: 2.83333,
    stroke: "#5078C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 20.5C9.25544 20.5 8.30161 20.1049 7.59835 19.4017C6.89509 18.6984 6.5 17.7446 6.5 16.75V14.5C6.5 14.3011 6.57902 14.1103 6.71967 13.9697C6.86032 13.829 7.05109 13.75 7.25 13.75C7.44891 13.75 7.63968 13.829 7.78033 13.9697C7.92098 14.1103 8 14.3011 8 14.5V16.75C8 17.3467 8.23705 17.919 8.65901 18.341C9.08097 18.7629 9.65326 19 10.25 19H17.75C18.3467 19 18.919 18.7629 19.341 18.341C19.7629 17.919 20 17.3467 20 16.75V14.5C20 14.3011 20.079 14.1103 20.2197 13.9697C20.3603 13.829 20.5511 13.75 20.75 13.75C20.9489 13.75 21.1397 13.829 21.2803 13.9697C21.421 14.1103 21.5 14.3011 21.5 14.5V16.75C21.5 17.7446 21.1049 18.6984 20.4016 19.4017C19.6984 20.1049 18.7446 20.5 17.75 20.5H10.25Z",
    fill: "#5078C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2855 12.175C18.3545 12.2454 18.4089 12.3288 18.4456 12.4203C18.4823 12.5117 18.5006 12.6095 18.4995 12.7081C18.4984 12.8067 18.4778 12.9041 18.4391 12.9947C18.4003 13.0853 18.344 13.1674 18.2735 13.2363L14.8985 16.5363C14.7584 16.6732 14.5702 16.7499 14.3743 16.7499C14.1783 16.7499 13.9901 16.6732 13.85 16.5363L10.475 13.2363C10.4031 13.1678 10.3455 13.0857 10.3055 12.9947C10.2656 12.9038 10.2441 12.8058 10.2423 12.7065C10.2405 12.6072 10.2585 12.5085 10.2952 12.4162C10.3318 12.3239 10.3865 12.2398 10.4559 12.1688C10.5253 12.0978 10.6082 12.0412 10.6996 12.0025C10.7911 11.9638 10.8893 11.9436 10.9886 11.9431C11.088 11.9426 11.1864 11.9619 11.2782 11.9998C11.37 12.0376 11.4534 12.0934 11.5235 12.1638L13.6243 14.218V7.75C13.6243 7.55109 13.7033 7.36032 13.8439 7.21967C13.9846 7.07902 14.1753 7 14.3743 7C14.5732 7 14.7639 7.07902 14.9046 7.21967C15.0452 7.36032 15.1243 7.55109 15.1243 7.75V14.218L17.2243 12.1638C17.2947 12.0948 17.378 12.0404 17.4695 12.0037C17.561 11.967 17.6588 11.9487 17.7574 11.9498C17.8559 11.9509 17.9533 11.9714 18.0439 12.0102C18.1346 12.049 18.2166 12.1052 18.2855 12.1758V12.175Z",
    fill: "#5078C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDownloadIcon);
export default __webpack_public_path__ + "static/media/Blue_DownloadIcon.90b8eeb1d3eaf000df66ea209db5b567.svg";
export { ForwardRef as ReactComponent };